import axios from 'axios';

const API_URL = 'https://backend.gouniquejourneys.co.uk/api/employee/requests'; // Update with actual backend URL

export const fetchRequests = async () => {
  try {
    const response = await axios.get(`${API_URL}/assigned-requests`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};

export const updateRequestStatus = async (requestId, status) => {
  try {
    const response = await axios.put(`${API_URL}/update-request-status/${requestId}`, { status }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating request status:', error.response?.data || error.message);
    throw error;
  }
};
